'use strict';

const genericFlyout = require('../../genericFlyout');
const writeACard = require('../../write-a-card');
const ajax = require('../../modules/ajax');
const dragList = require('../../dragList');

function init() {
    giftCartReview();
    giftCartEdit();
    giftCartCancel();
}

function giftCartReview() {
    $(document).on('click.giftcard', giftCardUtils.reviewGiftCardButton , function (event) {
        event.preventDefault();
        const options = {url: $(this).data('preview-url')};
        $.extend(options, giftCardUtils.flyoutOptions);
        genericFlyout.load(options);
    });
}

function giftCartEdit() {
    $(document).off('submit.giftcard').on('submit.giftcard', giftCardUtils.editForm , function (event) {
        event.preventDefault();
        const form = $(this);
        ajax.postForm({
            form: form,
            handleJson: postCallback
        });
    });
}

function giftCartCancel() {
    $(document).on('click.cancel', giftCardUtils.cancel , function (event) {
        event.preventDefault();
        genericFlyout.closeFlyouts();
    });
}

function openCallback(){
    writeACard.init();
    dragList.init();
}

function postCallback(response) {
    if (response.error){
        //TODO handle error somehow
        return;
    }
    appendNewMessage(response);

    genericFlyout.closeFlyouts();
}

function appendNewMessage(response){
    const giftCardElement = $('[data-giftcard-uuid="' + response.UUID + '"]');
    let giftCardMessageElement = $('.js-giftcard-message', giftCardElement);

    const $giftWrapText = $('#GiftWrapText');
    if ($giftWrapText.length) {
        $giftWrapText.val(response.originalMessageText);
    }

    if (!response.giftCardMessage){
        giftCardMessageElement.remove();
        return;
    }

    if (giftCardMessageElement.length){
        giftCardMessageElement.html(response.giftCardMessage);
        return;
    }
    giftCardMessageElement = $('<span />', {
        class: 'bundle-pg-cart-excerpt js-giftcard-message',
    }).html(response.giftCardMessage).insertBefore($(giftCardUtils.reviewGiftCardButton, giftCardElement));

}

const giftCardUtils = {
    flyoutOptions: {
        open: openCallback
    },
    editForm: '.js-edit-gift-card',
    cancel: '.js-cancel-giftcard-edit',
    reviewGiftCardButton: '.js-gift-card-preview',
    init: init
};

module.exports = giftCardUtils;
